import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function phone({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 19 21"
      stroke="black"
      width="19"
      height="21"
      className={className}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        d="M18.482 17.517L18 18c-1.49 1.49-7 2-12.5-3.5S.5 3.5 2 2l.491-.491a1.75 1.75 0 012.693.267l2.02 3.03a1.75 1.75 0 01-.218 2.208L5.937 8.063c-.268.268-.357.663-.183.999.32.613.984 1.676 2.246 2.938 1.262 1.262 2.325 1.927 2.938 2.246.336.175.731.085 1-.183l1.048-1.049a1.75 1.75 0 012.208-.218l3.02 2.013a1.76 1.76 0 01.268 2.708z"
      />
    </svg>
  );
}

export default phone;
